import $ from "jquery";

const blogAndArticle = {
    variable:{
        url: window.location.href,
    },
    methods : {
         dataLayerObj : function(e){
                var obj = {
                    'articleName' : "",
                    'blogCategory' : "",
                    'blogPageCategory' : "",
                    'buttonText' : e.currentTarget.innerText.replace(/\n/g, '').trim(),
                    'pageSection' : "Blogs and Articles Category",
                    'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? blogAndArticle.variable.url.includes("blog") ? "Blogs" : blogAndArticle.variable.url.substring(blogAndArticle.variable.url.indexOf(".com/"), blogAndArticle.variable.url.lastIndexOf('/')  === ".com") && !blogAndArticle.variable.url.substring(blogAndArticle.variable.url.indexOf(".com/"), blogAndArticle.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                    'planOption' : "",
                    'productCategory' : "",
                    'productName' : "",
                    'question' : "",
                    'source' : "",
                    'searchTerm' : "",
                    'videoTitle' : "",
                    'bannerName' : " ",

                };
                return obj;
        }
    }
};

$(() => {
    $('.blogs-and-categories--tab').on('click', function(e){
        var obj = blogAndArticle.methods.dataLayerObj(e);
        createDataLayer('buttonClick', obj);
    });
});
